import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Subject} from 'rxjs';
import {map} from 'rxjs/operators';
import {MaintenanceService} from '../maintenance/maintenance.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class MarketingService {
    data: any = {};
    dataUpdated$ = new Subject();

    origin = 'www.xref.com/pages';
    defaultResource = 'login-marketing-section';
    resource = this.defaultResource;
    isClassic = true;

    constructor(
        private http: HttpClient,
        private maintenance: MaintenanceService
    ) {}

    hasData(): boolean {
        return this.data.hasOwnProperty('announcement');
    }

    // Take the success parsed into the function, perform local logic first then parsed success
    responseSuccess = (data: any, successCallback: any) => {
        this.data = this.reduce(data.data);
        this.dataUpdated$.next(true);
        successCallback(this.data);
    };

    // Take the error parsed into the function, perform local logic first then parsed success
    responseError = (err: any, errorCallback: any) => {
        switch (err.status) {
            case 503:
                if (this.isClassic) {
                    this.maintenance.setMaintenance();
                }
                break;
            default:
                errorCallback(err);
                break;
        }
    };

    // @success <optional>: A success method parsed from the caller to be executed in that context
    // @error <optional>: An error method parsed from the caller to be executed in that context
    getMarketingAnnouncement(success: any = () => {}, error: any = () => {}, force = false): void {
        const successWrapped = (data: any) => {
            this.responseSuccess(data, success);
        };

        const errorWrapped = (err: any) => {
            this.responseError(err, error);
        };

        if (!this.hasData() || force) {
            this.http.get(`${environment.AUTH_API}status/marketing_announcement`)
                .pipe(map(res => res))
                .subscribe(successWrapped, errorWrapped);

        } else {
            success(this.data);
        }
    }

    setMarketingResource(resource: string = '') {
    // Assign the marketing iFrame resource
        if (this.data.announcement === 'maintenance') {
            this.resource = 'scheduled-maintenance';

        } else if (resource) {
            // Set resource to the value parsed from router
            this.resource = resource;

        } else {
            // Set to global default
            this.resource = this.defaultResource;
        }
    }

    private reduce(data: any): any {
        const reducedData: any = {};
        Object.assign(reducedData, data);
        return reducedData;
    }
}
